import { ComponentProps } from 'react'
import { Img } from '~/components/elements/Img'
import { Time } from '~/components/elements/Time'
import { ClockIcon } from '~/components/icons/generated/ClockIcon'
import { MovieIcon } from '~/components/icons/generated/MovieIcon'
import { ItemFooter } from '~/features/shared/components/Card/ItemFooter'
import { dateFormatDeltaOrYMD } from '~/lib/dateUtil'

type VideoCard = {
  imageUrl: string
  imageAlt: string
  publishedAt: string
  itemProps: ComponentProps<typeof ItemFooter>
  href: string
  imagePriority?: boolean
  imageFetchPriority?: boolean
}

export const VideoCard: React.FC<VideoCard> = ({
  imageUrl,
  imageAlt,
  publishedAt,
  itemProps,
  href,
  imagePriority,
  imageFetchPriority = false,
}) => {
  return (
    <div className="overflow-hidden xl:rounded-[3px] xl:border xl:border-gray-300">
      <a href={href} className="relative block bg-black xl:hover:opacity-70">
        <Img
          width="232"
          height="413"
          src={imageUrl}
          alt={imageAlt}
          className="aspect-[9/16] w-full object-contain"
          priority={imagePriority}
          fetchPriority={imageFetchPriority ? 'high' : 'auto'}
        />
        <MovieIcon
          className="absolute left-2 top-2 h-5 text-white drop-shadow-[0px_0px_4px_#00000066] xl:left-[9px] xl:top-[9px] xl:h-6"
          aria-hidden
        />
        <p className="absolute bottom-[9px] left-2 hidden items-center gap-1 text-[12px] leading-none text-white text-shadow-[1px_1px_1.5px_rgba(0,0,0,0.6)] xl:flex">
          <ClockIcon
            className="inline-block h-3 drop-shadow-[1px_1px_1px_#000]"
            aria-label="投稿日時"
          />
          <Time dateTime={publishedAt} ssrFallback="">
            {dateFormatDeltaOrYMD(publishedAt)}
          </Time>
        </p>
      </a>
      <div className="hidden xl:block">
        <ItemFooter {...itemProps} />
      </div>
    </div>
  )
}
